const api_key = "7738d9659bdc636a1d3e07b4f72fbaec";

const requests = {
  fetchTrending: `trending/movie/week?api_key=${api_key}`,
  fetchNetflixOriginals: `discover/tv?api_key=${api_key}&with_network=213`,
  fetchTopRated: `movie/top_rated?api_key=${api_key}&language=en-US`,
  fetchActionMovies: `discover/movie?api_key=${api_key}&language=en-US&with_genres=28`,
  fetchComedyMovies: `discover/movie?api_key=${api_key}&language=en-US&with_genres=35`,
  fetchHorrorMovies: `discover/movie?api_key=${api_key}&language=en-US&with_genres=27`,
  fetchRomanceMovies: `discover/movie?api_key=${api_key}&language=en-US&with_genres=10749`,
  fetchDocumentries: `discover/movie?api_key=${api_key}&language=en-US&with_genres=99`,
};

export default requests;
